import React from 'react';
import './WhatsappButton.css';

const WhatsappButton = ({ phoneNumber }) => {
  const url = `https://wa.me/${phoneNumber}`;
  return (
    <a href={url} className="whatsapp-float" target="_blank" rel="noopener noreferrer" title="Fale conosco no WhatsApp">
      <img src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/whatsapp.svg" alt="WhatsApp" />
    </a>
  );
};

export default WhatsappButton;
